export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            关于51暗网吃瓜
          </h2>
          <div className="mt-6 space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>
              <strong className="text-foreground-800">51暗网吃瓜</strong>是一个专注于<strong className="text-foreground-800">吃瓜视频</strong>在线观看与资源聚合的内容平台。
              我们整合<strong className="text-foreground-800">51吃瓜在线</strong>、<strong className="text-foreground-800">51cg吃瓜</strong>等多频道优质内容，
              提供<strong className="text-foreground-800">暗网吃瓜视频</strong>的流畅高清播放体验。
            </p>
            <p>
              平台每日追踪网络热点，覆盖娱乐八卦、社会事件、网络热议等多个领域，
              让<strong className="text-foreground-800">在线暗网吃瓜</strong>变得更加简单高效。我们坚持匿名化运营，保护每一位用户的浏览隐私，
              打造安全、纯粹的<strong className="text-foreground-800">51吃瓜视频在线</strong>观看环境。
            </p>
            <p>
              从<strong className="text-foreground-800">暗网吃瓜直播</strong>到精选录播，
              从热门话题追踪到深度内容整理，51暗网吃瓜始终站在吃瓜前线，
              做您最可靠的吃瓜伙伴。
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-8 mt-10 pt-8 border-t border-background-200/70">
            <div className="text-center">
              <p className="text-3xl font-bold font-heading text-primary-500">50,000+</p>
              <p className="text-xs text-foreground-500 mt-1">日均访问用户</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold font-heading text-accent-500">10,000+</p>
              <p className="text-xs text-foreground-500 mt-1">累计视频资源</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold font-heading text-primary-500">24/7</p>
              <p className="text-xs text-foreground-500 mt-1">全天候更新</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}